// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"329b8d8f","732":"62581355","977":"4c9f9f6c"}[chunkId] + ".chunk.js";
};